<template>
  <v-container>
    <v-alert shaped prominent type="error" v-if="notFound">
      El formulario seleccionado no existe o fue imposible recuperar la
      informaicón
    </v-alert>
    <v-progress-circular
      indeterminate
      class="loading"
      color="primary"
      v-if="loading"
    >
      Cargando
    </v-progress-circular>
    <v-layout v-else>
      <v-flex>
        <v-list v-for="(error, err) in errors" :key="err">
          <v-alert v-if="errors.length" border="top" color="red lighten-2">{{
            error
          }}</v-alert>
        </v-list>
        <v-card elevation="2" color="#f0f2f5" style v-if="isDataLoaded">
          <!-- sections for form -->

          <v-list
            v-for="(section, s) in questions"
            :key="s"
            style="max-width: 100%; margin-left: 5%; margin-right: 5%"
          >
            <v-card v-if="section.questions.length" color="#f0f2f6">
              <v-card-title
                class="questionText"
                style="margin-left: 5%; font-size: 200%; font-weight: bold"
                >{{ section.title }}</v-card-title
              >

              <!-- Questions it self -->
              <v-list
                v-for="(question, i) in section.questions"
                :key="i"
                style="max-width: 100%; margin-left: 5%; margin-right: 5%"
              >
                <v-list-item-content v-if="LoadQuestion(question)">
                  <!-- Questions  -->
                  <selectAnswerComponentTextVue
                    class="questionText"
                    :question="question"
                    v-if="isSelectQuestion(question)"
                    :questionNumber="getNum(question)"
                    :disabled="true"
                    :answer="final.get(getNum(question)).answer"
                  />
                  <multiAnswerComponentVue
                    class="questionText"
                    :question="question"
                    v-if="isCheckQuestion(question)"
                    :questionNumber="getNum(question)"
                    :disabled="true"
                    :answer="final.get(getNum(question)).answer"
                  />
                  <textAnswerVue
                    :question="question"
                    class="questionText"
                    v-if="isTextQuestion(question)"
                    :questionNumber="getNum(question)"
                    :disabled="true"
                    :answer="final.get(getNum(question)).answer"
                  />
                  <tableAnswerComponentVue
                    :question="question"
                    class="questionText"
                    v-if="isTableQuestion(question)"
                    :questionNumber="getNum(question)"
                    :disabledAnswers="true"
                    :answer="final.get(getNum(question)).answer"
                  />
                  <dropAnswerComponentVue
                    :question="question"
                    :key="question.number"
                    :options="option.get(getNum(question))"
                    class="question"
                    :disabled="true"
                    v-if="isDropQuestion(question)"
                    :questionNumber="getNum(question)"
                    :answer="final.get(getNum(question)).answer"
                  />
                </v-list-item-content>
              </v-list>
            </v-card>
          </v-list>
          <finalInfoComponentVue
            style="width: 90%; margin-left: 5%; margin-right: 5%"
            :fillingResponsable="registro.fillingResponsable"
            :liftingDate="registro.liftingDate"
            :disabled="true"
          />
        </v-card>

        <v-card style="margin-top: 2em; margin-bottom: 2em">
          <div
            id="evidences"
            v-for="evidence in evidences"
            :key="evidence.name"
          >
            <v-row>
              <label
                style="margin-left: 2%; padding-top: 1%"
                @click="downloadFile(evidence.id, evidence.name)"
              >
                {{ evidence.name }}</label
              >
              <v-spacer></v-spacer>
              <v-icon style="margin-right: 2%" @click="removeFile(evidence)"
                >mdi-delete</v-icon
              >
            </v-row>
          </div>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { getQuestions, getFormByCode, getEvidenceFile } from "@/utils/apiRequest.js";
import textAnswerVue from "@/components/textAnswer.vue";
import selectAnswerComponentTextVue from "@/components/selectAnswerComponentText.vue";
import multiAnswerComponentVue from "@/components/multiAnswerComponentText.vue";
import tableAnswerComponentVue from "@/components/tableAnswerComponent.vue";
import dropAnswerComponentVue from "@/components/dropAnswerComponent.vue";
import finalInfoComponentVue from "@/components/finalInfoComponent.vue";
import FileSaver from "file-saver";
export default {
  data() {
    return {
      prevQuestions: 0,
      questions: [],
      answers: [],
      parsedResponse: new Map(),
      final: new Map(),
      demo: false,
      domain: "",
      name: "",
      goal: "",
      loading: true,
      subdomainDrop: [],
      evidences: [],
      obunit: "",
      errors: [],
      domainDrop: [],
      registro: {},
      option: new Map(),
      notFound: false,
    };
  },

  computed: {
    isDataLoaded() {
      return this.registro.answers != null;
    },
  },
  components: {
    textAnswerVue,
    multiAnswerComponentVue,
    selectAnswerComponentTextVue,
    tableAnswerComponentVue,
    dropAnswerComponentVue,
    finalInfoComponentVue,
  },
  methods: {
    getNum(question) {
      return question.section.toString() + "." + question.number;
    },
    getAnswerValue(question, registro) {
      let val = "";
      registro.answers.forEach((answer) => {
        if (answer.question == question.question) {
          val = answer.answer;
          return;
        }
      });
      return val;
    },
    async downloadFile(id, name) {
      let response = await getEvidenceFile(id);
      FileSaver.saveAs(response.data, name);
    },
    LoadQuestion(question) {
      if (
        question.dependency != null &&
        question.dependency != "" &&
        question.dependency != "0"
      ) {
        if (question.condition) {
          let conditions = question.condition.split(";");
          if (conditions.length > 0) {
            let val = false;
            conditions.forEach((condition) => {
              if (
                condition == this.answers[question.dependency] ||
                this.final.get(question.dependency).answer == condition
              ) {
                val = true;
              }
            });
            return val;
          }
          return false;
        }
        if (this.final.get(question.dependency) == undefined) {
          return this.answers[question.dependency] == "Si";
        }
        return (
          this.answers[question.dependency] == "Si" ||
          this.final.get(question.dependency).answer == "Si"
        );
      }
      return true;
    },
    isSelectQuestion(question) {
      return question.type == "select";
    },
    isTableQuestion(question) {
      return question.type.includes("table");
    },
    isDropQuestion(question) {
      return question.type == "aux";
    },
    isCheckQuestion(question) {
      return question.type.includes("multi");
    },
    isTextQuestion(question) {
      return question.type == "text";
    },
    hasSpecifyText(options) {
      if (options == null) {
        return false;
      }
      return options.includes("especifique");
    },
    prepareDropDown() {
      let questionArray = ["1.5", "1.6", "1.7"];
      this.questions.forEach((sector) => {
        if (questionArray.length == 0) {
          return;
        }
        sector.questions.forEach((question) => {
          if (questionArray.length == 0) {
            return;
          }
          if (questionArray.includes(this.getNum(question))) {
            let options = question.options.split(";");
            this.option.set(this.getNum(question), options);
            const index = questionArray.indexOf(this.getNum(question));
            if (index > -1) {
              questionArray.splice(index, 1);
            }
          }
        });
      });
    },
  },
  async setup() {},
  async created() {},

  async mounted() {
    let response = await getQuestions();
    if (response.data.status == "success") {
      this.questions = response.data.sections;
    }

    response = await getFormByCode(this.$route.params.id);
    if (response.data.status == "success") {
      let registro = response.data.forms;

      this.questions.forEach((section) => {
        section.questions.forEach((question) => {
          let val = this.getAnswerValue(question, registro);
          this.final.set(this.getNum(question), {
            question: question,
            answer: val,
          });
        });
      });
      this.registro = registro;
      this.evidences = registro.evidences;
      this.loading = false;
      this.prepareDropDown();

      return;
    }

    this.loading = false;
    this.notFound = true;
  },
};
</script>

<style scoped>
.questionText {
  overflow-wrap: break-word;
}

.labelButton {
  padding: 1% 1%;
  align-content: center;
  color: #fff;
  background-color: #4f9be1;
  transition: 0.3s ease all;
}
.required ::after {
  content: "*";
}
#dropzoneFile {
  display: none;
}

.identification-answer {
  width: 50%;
  max-width: 550px;
  margin-left: auto;
  align-content: right;
}

.loading {
  position: absolute;
  left: 50%;
  margin: 25% 0 0 0;
}
</style>